import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { canUseDOM } from './index';
export function useIsVisible(ref) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isIntersecting = _useState2[0],
    setIntersecting = _useState2[1];
  useEffect(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];
      if (canUseDOM) {
        setIntersecting(entry.isIntersecting);
      }
    });
    observer.observe(ref.current);
    return function () {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}